import React from 'react';
import {Link} from 'react-router';

type MypageBreadcrumbProps = {
  children: React.ReactNode;
};

const MypageBreadcrumb = ({children}: MypageBreadcrumbProps) => (
  <nav className="mb-4 flex flex-wrap items-center gap-1 text-sm text-gray-500">
    {children}
  </nav>
);

type BreadcrumbItemLinkProps = {
  to: string;
  children: React.ReactNode;
};

const BreadcrumbItemLink = ({to, children}: BreadcrumbItemLinkProps) => (
  <>
    <Link to={to} className="hover:underline">
      {children}
    </Link>
    <span className="mx-1">/</span>
  </>
);

type BreadcrumbItemProps = {
  children: React.ReactNode;
};

const BreadcrumbItem = ({children}: BreadcrumbItemProps) => (
  <span className="text-gray-700">{children}</span>
);

MypageBreadcrumb.ItemLink = BreadcrumbItemLink;
MypageBreadcrumb.Item = BreadcrumbItem;

export {MypageBreadcrumb as Breadcrumb};
